import { ThemeProvider } from '@mui/material';
import { useAppVersion, useTitleEffect } from 'hive-react-utils';
import { useEffect } from 'react';
import {
  CommonDataContextProvider,
  MessageBarProvider,
} from 'ontariohealth-shared-utilities';
import Geocode from 'react-geocode';

import { userTheme } from './theme';
import Main from './content/Main';
import { DataContextProvider } from './contexts/DataContext';

const GOOGLE_API_KEY =
  process.env.REACT_APP_GOOGLE_API_KEY ||
  (window as any)._env_.REACT_APP_GOOGLE_API_KEY;

export default function App() {
  useTitleEffect('app.title');

  const { version } = useAppVersion();

  useEffect(() => {
    Geocode.setApiKey(GOOGLE_API_KEY);
    console.debug(`App Version: ${version}`);
  }, [version]);

  useEffect(() => console.debug(`App Version: ${version}`), [version]);

  return (
    <ThemeProvider theme={userTheme}>
      <MessageBarProvider>
        <CommonDataContextProvider>
          <DataContextProvider>
            <Main />
          </DataContextProvider>
        </CommonDataContextProvider>
      </MessageBarProvider>
    </ThemeProvider>
  );
}
